import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingRequestManagementServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestManagementServices";

const RevokeStudyUnblindRequestManagement = ({
  requestData,
  getEIWRSUnblindingRequestData,
  getEIWRSUnblindingRequestStats,
  Show,
  Hide,
  Title,
  setRequestId,
}) => {
  const { studyId } = useParams()
  const [revokedComment, setRevokedComment] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const reviewEIWRSUnblindingRequestData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Revoke this request!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, revoke it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = requestData?._id;
        userData.studyId = studyId;
        userData.status = "revoked";
        userData.revokedComment = revokedComment;
        userData.mode = StudyMode;
        let data = await eiwrsUnblindingRequestManagementServices.reviewEIWRSUnblindingRequestData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingRequestData();
          getEIWRSUnblindingRequestStats();
          Hide();
          setRequestId("");
          setRevokedComment("");
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Revoke Comment <abbr title="Required" className="text-danger"> *</abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setRevokedComment(e.target.value)}
              value={revokedComment}
              className="br3"
              placeholder="Enter Revoke Comment"
              as="textarea"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!revokedComment || buttonLoader}
            className="updateProfile"
            onClick={(e) => reviewEIWRSUnblindingRequestData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Revoking...
              </div>
            ) : (
              "Revoke Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default RevokeStudyUnblindRequestManagement;
